export default __webpack_public_path__ + "static/media/blog.10e2a420.png";